import { analyticsGoals, trackAnalyticsGoal } from '../../lib/analytics/yandexMetrika';
import { purchaseData } from './purchaseData';
import styles from './PurchaseSection.module.scss';

export function PurchaseSection() {
  return (
    <section className={styles.section} id="purchase" aria-labelledby="purchase-title">
      <header className={styles.header} data-reveal>
        <div className={styles.heading}>
          <p className={styles.eyebrow}>{purchaseData.eyebrow}</p>
          <h2 id="purchase-title">{purchaseData.title}</h2>
        </div>
        <p className={styles.lead}>{purchaseData.lead}</p>
      </header>

      <ol className={styles.steps} aria-label="Этапы покупки участка">
        {purchaseData.steps.map((step, index) => (
          <li
            className={styles.step}
            key={step.number}
            data-reveal
            data-reveal-delay={index > 0 ? String(Math.min(index, 2)) : undefined}
          >
            <span className={styles.stepNumber}>{step.number}</span>
            <div className={styles.stepBody}>
              <h3>{step.title}</h3>
              <p>{step.description}</p>

              {'link' in step ? (
                <a
                  className={styles.genplanLink}
                  href={step.link.href}
                  onClick={() => trackAnalyticsGoal(analyticsGoals.lotSelectClick)}
                >
                  {step.link.label}
                </a>
              ) : null}
            </div>
          </li>
        ))}
      </ol>

      <div className={styles.paymentBand} aria-labelledby="payment-title">
        <header className={styles.paymentHeader} data-reveal>
          <p className={styles.paymentEyebrow}>{purchaseData.payment.eyebrow}</p>
          <h3 id="payment-title">{purchaseData.payment.title}</h3>
        </header>

        <div className={styles.paymentOptions}>
          {purchaseData.payment.options.map((option, index) => (
            <article
              className={styles.paymentOption}
              key={option.number}
              data-reveal
              data-reveal-delay={index > 0 ? String(index) : undefined}
            >
              <span className={styles.paymentNumber}>{option.number}</span>
              <h4>{option.title}</h4>

              {'facts' in option ? (
                <div className={styles.paymentFacts}>
                  {option.facts.map((fact) => (
                    <strong key={fact}>{fact}</strong>
                  ))}
                </div>
              ) : null}

              <p className={styles.paymentDescription}>{option.description}</p>
            </article>
          ))}
        </div>
        {/* <p className={styles.paymentLegalNote} data-reveal>
          {purchaseData.payment.note}
        </p> */}
      </div>
    </section>
  );
}
